import { createFocusTrap } from "focus-trap";

// Avoid alpinejs so that the parent component of the overlay has access to the x-refs inside the overlay
class Modal {
  root = null;
  inner = null;
  focusTrap = null;
  isOpen = false;

  constructor(root) {
    this.root = root;
    this.inner = root.querySelector(".modal-inner");

    this.initFocusTrap();
    this.setupEventListener();
  }

  initFocusTrap() {
    this.focusTrap = createFocusTrap(this.inner, {
      initialFocus: this.inner.querySelector("button"),
      escapeDeactivates: false, // Custom logic to handle this
      clickOutsideDeactivates: false, // Custom logic to handle this
      allowOutsideClick: true,
    });
  }

  setupEventListener() {
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.close();
      }
    });

    // Outside click
    this.root.addEventListener("click", (e) => {
      if (e.target === this.root) {
        this.close();
      }
    });
  }

  open() {
    if (this.isOpen) {
      return;
    }

    this.isOpen = true;

    // Handle visibility
    this.root.style.setProperty("display", "block");
    this.root.clientHeight;

    // Handle body scroll
    // Force disabled scroll (apparently plyrjs inside a modal removes the overflow:hidden style from the body on init...)
    document.body.classList.add("!overflow-hidden");
    window.disableBodyScroll(this.inner, {
      reserveScrollBarGap: true,
    });

    // Handle focus
    this.focusTrap.activate();
  }

  close() {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;

    // Handle visibility
    this.root.style.setProperty("display", "none");
    this.root.clientHeight;

    // Handle body scroll
    document.body.classList.remove("!overflow-hidden");
    window.enableBodyScroll(this.inner);

    // Handle focus
    this.focusTrap.deactivate();

    // Stop videos
    this.root.querySelector(`[data-video-component]`)?.dispatchEvent(new CustomEvent('stop-video'));
  }
}

// Save all modals in global object
window.modals = {};
document.querySelectorAll("[data-modal]").forEach((el) => {
  window.modals[el.dataset.modal] = new Modal(el);
});

// Helper function to find dynamic modals
window.findModal = (id) => {
  const modal = document.querySelector(`[data-modal='${id}']`);

  if (!modal) {
    console.warn("Unable to find modal with id " + id);
  }

  window.modals[id] = new Modal(modal);
};

// Helper function to set modal
window.setModal = (id, el) => {
  if (!el.dataset.modal) {
    console.warn("Missing data-modal attribute on modal with id " + id);
  }

  window.modals[id] = new Modal(el);
};

// Global helper functions to toggle modals
window.openModal = (id) => {
  if (!window.modals[id]) {
    console.warn("No modal with id " + id);
    return;
  }

  window.modals[id].open();
};

window.closeModal = (id) => {
  if (!window.modals[id]) {
    console.warn("No modal with id " + id);
    return;
  }

  window.modals[id].close();
};
